import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { initialEReceiptPreferences } from './tableData';

import EReceiptCard from './common/EReceiptCard';
import ErrorBoundary from '../contexts/ErrorBoundary';
import { BannerContext, BannerProvider } from '../contexts/BannerContext';
import { setupEReceiptPreferenceRetrieve } from '../apis/common';
import { fetchProfileData } from '../apis/account';

export function Preferences({ sendInitialEReceipt, sendUpdated }) {
  const { openErrorAlert } = useContext(BannerContext);

  const [tableData, setTableData] = React.useState(initialEReceiptPreferences());
  const [eReceiptPrefChecked, setEReceiptPrefChecked] = React.useState(null);
  const handleEReceiptPrefRetrieve = setupEReceiptPreferenceRetrieve(setEReceiptPrefChecked, sendInitialEReceipt);

  function handleError() {
    openErrorAlert();
  }

  useEffect(() => {
    fetchProfileData(handleEReceiptPrefRetrieve, handleError);
  }, []);

  return (
    <EReceiptCard
      tableData={tableData}
      preference={eReceiptPrefChecked}
      sendUpdated={sendUpdated}
    />
  );
}

function ProEReceiptPreferences({ sendInitialEReceipt, sendUpdated }) {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences sendInitialEReceipt={sendInitialEReceipt} sendUpdated={sendUpdated} />
      </BannerProvider>
    </ErrorBoundary>
  );
}

export default ProEReceiptPreferences;

const proptypes = {
  sendInitialEReceipt: PropTypes.func.isRequired,
  sendUpdated: PropTypes.func.isRequired
};

ProEReceiptPreferences.propTypes = proptypes;
Preferences.propTypes = proptypes;
